import { Component, Input } from "@angular/core";
import { ProvidersService } from "fccore2";
import { FcinputComponent } from "../fcinput";
/**
 * fc-tagæ ç­¾
 * 
 * è¿è¡æ è®°ååç±»çå°æ ç­¾ã
 * 
 * ç¨äºæ è®°äºç©çå±æ§åç»´åº¦ã
 * 
 * è¿è¡åç±»ã
 * 
 * äºä»¶ï¼
 * 
 * 1.å³é­äºä»¶ï¼close
 * 
 * 2.éä¸­äºä»¶ï¼check
 * 
 * 3.ç¹å»äºä»¶ï¼click
 * 
 */
@Component({
  selector: 'fc-tag',
  template: `
  <nz-tag [nzMode]="fcMode" [nzColor]="fcColor" (click) = "_click($event)" (nzOnClose)="_close($event)" (nzAfterClose)="afterClose($event)" 
  [nzChecked]="fcChecked"  
  (nzCheckedChange)="_handleChange($event)">
      <span [ngClass]="{'fc-tag-small':fcSize === 'small','fc-tag-default':fcSize === 'default','fc-tag-large':fcSize === 'large'}">
      <i class="icon iconfont {{fcIcon}}" *ngIf="fcIcon!==undefined"></i><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</span>
  </nz-tag>
`,
  styles: [`
  .fc-tag-small , .fc-tag-small i{
      font-size:12px;
  }
  .fc-tag-default , .fc-tag-default i{
      font-size:14px;
  }
  .fc-tag-large , .fc-tag-large i{
      font-size:16px;
  }
  `]
})
export class FctagComponent extends FcinputComponent {
  _checked = true;
  /**æ é¢*/
  @Input()
  fcLabel: string;
  /**å¼*/
  @Input()
  fcValue: string;
  /**å¾æ */
  @Input()
  fcIcon: string;
  /**é¢è²*/
  @Input()
  fcColor: string;
  /**æ ç­¾å·¥ä½æ¨¡å¼ï¼å³é­/éä¸­/æ­£å¸¸*/
  @Input()
  fcMode: string;
  /**æ ç­¾çéä¸­ç¶æ*/
  @Input()
  fcChecked: string;
  _check: boolean = false;
  constructor(public provider: ProvidersService) {
    super(provider, 'fc`-tag');
  }
  _afterParentInit() {
    if (this.fcMode === undefined) {
      this.fcMode = TAGMODE.default;
    }
    /**é»è®¤fcCheckedæ¯å¯éä¸­ç¶æ*/
    if (this.fcChecked === 'Y') {
      this._check = true;
    } else {
      this._check = false;
    }
  }
  /**
   * å³é­æ ç­¾
   * @param event 
   */
  _close(event): void {
    this.event('close', { label: this.fcLabel, value: this.fcValue })
  }
  afterClose(event): void {
    this.event('afterClose', { label: this.fcLabel, value: this.fcValue })
  }
  /**
   * éä¸­æ ç­¾
   * @param checked 
   */
  _handleChange(checked: boolean): void {
    this.event('check', { label: this.fcLabel, value: this.fcValue, checked: this._checked })
  }
  /**
  * èªå·±æåºçclick
  * @param checked 
  */
  _click(ev: Event) {
    this.event('click', { event: ev })
  }
}
/**
* æ ç­¾å·¥ä½æ¨¡å¼
*/
export const TAGMODE = {
  closeable: 'closeable',
  default: 'default',
  checkable: 'checkable'
}
